/**
 * MAD-50 - Disclaimer ricambi erogatori non certificati
 * Gestisce la checkbox obbligatoria in pagina/drawer carrello: finché non è
 * spuntata, il pulsante "Vai al checkout" associato resta disabilitato.
 * Delegazione a livello di document per funzionare anche quando il drawer
 * del carrello viene ri-renderizzato via AJAX (Section Rendering API).
 */
document.addEventListener('change', function (event) {
  var checkbox = event.target;
  if (!checkbox || !checkbox.matches('[data-disclaimer-ricambi-checkbox]')) return;

  var scope = checkbox.closest('[data-disclaimer-ricambi-scope]') || document;
  var checkoutButton = scope.querySelector('[data-disclaimer-ricambi-checkout]');
  if (!checkoutButton) return;

  checkoutButton.disabled = !checkbox.checked;
});
